import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "../../lib/utils";

const AuthButton = ({
  className,
  ...props
}: React.ComponentProps<typeof Button>) => (
  <Button
    className={cn("w-full px-4 py-2 bg-gray-900 hover:bg-gray-800", className)}
    {...props}
  />
);

export { AuthButton };

interface AuthLayoutProps {
  title: string;
  subtitle: React.ReactNode;
  children: React.ReactNode;
  onSubmit: (event: React.FormEvent) => void;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title,
  subtitle,
  onSubmit,
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form onSubmit={onSubmit} className="w-full max-w-md">
        <div className="space-y-6">
          <div className="space-y-2 text-center">
            <h1 className="text-3xl font-bold tracking-tighter text-gray-900">
              {title}
            </h1>
            {subtitle && <p className="text-gray-500">{subtitle}</p>}
          </div>
          <div className="space-y-4">{children}</div>
        </div>
      </form>
    </div>
  );
};

export default AuthLayout;
